import { render, staticRenderFns } from "./ExpireActionManager.vue?vue&type=template&id=20a69fef"
import script from "./ExpireActionManager.vue?vue&type=script&lang=js"
export * from "./ExpireActionManager.vue?vue&type=script&lang=js"
import style0 from "./ExpireActionManager.vue?vue&type=style&index=0&id=20a69fef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports